const title = "Q63 当社に対して、総合的に満足している";
const xCategories = [
  "そう思う",
  "ややそう思う",
  "どちらともいえない",
  "ややそう思わない",
  "そう思わない"
];
const TotalESDegrees = data => ({
  chart: {
    type: "column"
  },
  title: {
    text: title
  },
  colors: ["#4FBF6D"],
  xAxis: {
    categories: xCategories,
    crosshair: true
  },
  yAxis: {
    min: 0,
    title: null,
    labels: {
      formatter() {
        return `${this.value} %`;
      }
    }
  },
  tooltip: {
    enabled: false
  },
  plotOptions: {
    series: {
      dataLabels: {
        enabled: true,
        format: `{y} %`
      }
    },
    column: {
      pointPadding: 0.2,
      borderWidth: 0
    }
  },
  series: [
    {
      name: null,
      data
    }
  ],
  legend: {
    enabled: false
  },
  credits: {
    enabled: false
  }
});

export default TotalESDegrees;



// WEBPACK FOOTER //
// ./src/models/TotalES.js